import { render, staticRenderFns } from "./AccountRecord.vue?vue&type=template&id=6ae52f56&scoped=true"
import script from "./AccountRecord.vue?vue&type=script&lang=js"
export * from "./AccountRecord.vue?vue&type=script&lang=js"
import style0 from "./AccountRecord.vue?vue&type=style&index=0&id=6ae52f56&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae52f56",
  null
  
)

export default component.exports